"use client"

import type { ReactNode } from "react"

import { PRODUCT_CHAT_DISABLED_MESSAGE } from "@/lib/product-chat-access"
import { PartnerAccessDisabled, PartnerAccessGate } from "@/components/partners/partner-access-gate"

export function ProductChatDisabled() {
  return <PartnerAccessDisabled message={PRODUCT_CHAT_DISABLED_MESSAGE} />
}

export function ProductChatGate({ children }: { children: ReactNode }) {
  return (
    <PartnerAccessGate capability="full_product_access" disabledMessage={PRODUCT_CHAT_DISABLED_MESSAGE}>
      {children}
    </PartnerAccessGate>
  )
}
